<template>
  <div>
    <!-- 顶部导航 -->
    <div>
      <van-nav-bar :title="$t('video.video')">
        <!--        <template #right>-->
        <!--          <van-icon-->
        <!--              name="chat-o"-->
        <!--              size="24"-->
        <!--              color="#fff"-->
        <!--              @click="toLogin('/ServiceOnline')"-->
        <!--          />-->
        <!--        </template>-->
      </van-nav-bar>
    </div>

    <!-- 固定影视分类 -->
    <div>
      <van-tabs
          v-model="active"
          title-inactive-color="rgb(68, 40, 137)"
          title-active-color="rgb(197, 113, 207)"
          line-height="10px"
          line-width="40px"
          @change="onChange"
      >
        <van-tab
            v-for="(item, index) in videolitem"
            :key="item.id"
            :name="item.id"
        >
          <template #title>
            <div class="tab-title">
              <span>{{ item.name }}</span>

              <span
                  v-if="index === 0"
                  class="new-mark"
              ></span>
            </div>
          </template>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 视频列表 -->
    <div>
      <van-pull-refresh
          v-model="refreshing"
          @refresh="onRefresh"
      >
        <van-list
            v-model="loading"
            :finished="finished"
            :immediate-check="false"
            loading-text=""
            finished-text=""
            @load="onLoad"
        >
          <div class="list-item">
            <div
                v-for="(item, index) in data"
                :key="getVideoKey(item, index)"
                class="movie-list-item"
                @click="toPlayVideo(item.id || item.vod_id)"
            >
              <div
                  class="cover_img van-image van-image--round"
                  style="width: 100%; height: 100px;"
              >
                <img
                    :src="item.vod_pic"
                    :alt="item.vod_name"
                    class="van-image__img"
                    @error="onImageError"
                />
              </div>

              <div
                  class="movie-list-item-bottom"
                  style="bottom: 33px;"
              >
                <div class="movie-time-div">
                  <span class="movie-name">
                    {{ item.vod_name }}
                  </span>

                  <span class="movie-count">
                    {{ $t("video.play") }} :{{ item.count || 0 }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 没有数据 -->
          <van-empty
              v-if="finished && data.length === 0"
              image="search"
              description="暫無影片"
          />
        </van-list>
      </van-pull-refresh>
    </div>

    <div style="height: 55px;"></div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "VideoList",

  data() {
    return {
      // 默认选中“人氣”
      active: 888,

      // 当前分类ID
      id: 888,

      // 固定分类
      videolitem: [],

      // 视频列表
      data: [],

      // 后端分页通常从1开始，不能从0开始
      page: 1,

      // 加载状态
      loading: false,
      finished: false,
      refreshing: false,

      // 页面是否已完成首次初始化
      initialized: false,

      // 当前请求标识，避免同一页重复请求
      requestingKey: "",

      // 请求版本号，切换分类或刷新后让旧请求自动失效
      requestVersion: 0,
    };
  },

  created() {
    this.initVideoClass();
  },

  mounted() {
    this.initialized = true;

    // 关闭 van-list 的 immediate-check 后，首次只主动请求一次
    this.$nextTick(() => {
      this.resetList();
      this.loadCurrentPage();
    });
  },

  methods: {
    /**
     * 初始化固定影视分类
     * 不再请求 video_class 接口
     */
    initVideoClass() {
      const lang = (
          localStorage.getItem("lang") || "zh"
      ).toLowerCase();

      const categories = [
        {
          id: 888,
          zh: "人氣",
          en: "Popular",
          ja: "人気",
          kr: "인기",
        },
        {
          id: 1,
          zh: "日韓",
          en: "J/K",
          ja: "日韓",
          kr: "한일",
        },
        {
          id: 2,
          zh: "亞洲",
          en: "Asia",
          ja: "アジア",
          kr: "아시아",
        },
        {
          id: 3,
          zh: "歐洲",
          en: "Europe",
          ja: "欧州",
          kr: "유럽",
        },
        {
          id: 4,
          zh: "動畫",
          en: "Anime",
          ja: "アニメ",
          kr: "애니",
        },
      ];

      this.videolitem = categories.map((item) => {
        return {
          id: item.id,
          name: this.getCategoryName(item, lang),
        };
      });

      this.active = 888;
      this.id = 888;
    },

    /**
     * 获取分类对应语言名称
     * 中文统一使用繁体
     */
    getCategoryName(item, lang) {
      if (
          lang === "kr" ||
          lang === "ko" ||
          lang === "ko-kr"
      ) {
        return item.kr;
      }

      if (
          lang === "ja" ||
          lang === "jp" ||
          lang === "ja-jp"
      ) {
        return item.ja;
      }

      if (
          lang === "en" ||
          lang.indexOf("en-") === 0
      ) {
        return item.en;
      }

      return item.zh;
    },

    /**
     * 重置当前列表
     */
    resetList() {
      this.requestVersion += 1;
      this.requestingKey = "";
      this.page = 1;
      this.data = [];
      this.finished = false;
      this.loading = false;
    },

    /**
     * 上拉加载下一页
     */
    onLoad() {
      if (!this.initialized || this.finished) {
        this.loading = false;
        return;
      }

      this.loadCurrentPage();
    },

    /**
     * 分类切换
     */
    onChange(name) {
      if (!this.initialized) {
        return;
      }

      const categoryId = Number(name);
      const nextId = Number.isNaN(categoryId)
          ? name
          : categoryId;

      // 初始化阶段或重复点击当前分类时不重新请求
      if (String(nextId) === String(this.id)) {
        return;
      }

      this.id = nextId;
      this.resetList();
      this.loadCurrentPage();
    },

    /**
     * 下拉刷新
     */
    onRefresh() {
      this.resetList();
      this.refreshing = true;
      this.loadCurrentPage();
    },

    /**
     * 加载当前页
     */
    loadCurrentPage() {
      if (this.finished) {
        this.loading = false;
        this.refreshing = false;
        return;
      }

      const currentId = this.id;
      const currentPage = this.page;
      const currentVersion = this.requestVersion;
      const requestKey = `${currentVersion}_${currentId}_${currentPage}`;

      // 防止 van-list、分类切换等重复触发同一页请求
      if (this.requestingKey === requestKey) {
        return;
      }

      this.requestingKey = requestKey;
      this.loading = true;

      this.requestVideoList(currentId, currentPage)
          .then((list) => {
            // 分类已切换或已刷新，丢弃旧请求返回的数据
            if (
                currentVersion !== this.requestVersion ||
                String(currentId) !== String(this.id)
            ) {
              return;
            }

            if (!Array.isArray(list) || list.length === 0) {
              this.finished = true;
              return;
            }

            const oldKeys = new Set(
                this.data.map((item, index) => {
                  return this.getVideoKey(item, index);
                })
            );

            const uniqueList = list.filter((item, index) => {
              const key = this.getVideoKey(item, index);

              if (oldKeys.has(key)) {
                return false;
              }

              oldKeys.add(key);
              return true;
            });

            // 即使后端分页偶尔返回重复页，也不会重复显示
            if (uniqueList.length > 0) {
              this.data = this.data.concat(uniqueList);
              this.page = currentPage + 1;
            } else {
              // 整页都是重复数据，停止继续加载，避免死循环请求
              this.finished = true;
            }
          })
          .catch((error) => {
            if (currentVersion === this.requestVersion) {
              console.error("Error fetching video list:", error);
              Toast.fail("載入失敗");
            }
          })
          .finally(() => {
            if (this.requestingKey === requestKey) {
              this.requestingKey = "";
              this.loading = false;
              this.refreshing = false;
            }
          });
    },

    /**
     * 请求指定分类、指定页的视频列表
     */
    requestVideoList(categoryId, page) {
      return this.$http({
        method: "get",
        url: "video_list",

        // 保留原项目请求封装的 data 传参方式
        data: {
          id: categoryId,
          page,
        },
      }).then((res) => {
        if (
            res &&
            res.data &&
            Array.isArray(res.data.data)
        ) {
          return res.data.data;
        }

        if (res && Array.isArray(res.data)) {
          return res.data;
        }

        if (
            res &&
            res.data &&
            Array.isArray(res.data.rows)
        ) {
          return res.data.rows;
        }

        return [];
      });
    },

    /**
     * 获取视频唯一键
     */
    getVideoKey(item, index = 0) {
      if (!item) {
        return `empty_${index}`;
      }

      if (
          item.id !== undefined &&
          item.id !== null &&
          item.id !== ""
      ) {
        return `id_${item.id}`;
      }

      if (
          item.vod_id !== undefined &&
          item.vod_id !== null &&
          item.vod_id !== ""
      ) {
        return `vod_id_${item.vod_id}`;
      }

      return [
        "video",
        item.vod_name || "",
        item.vod_pic || "",
      ].join("_");
    },

    /**
     * 点击影视进入播放页面
     */
    toPlayVideo(id) {
      if (
          id === undefined ||
          id === null ||
          id === ""
      ) {
        return;
      }

      this.$router.push({
        path: "/PlayVideo",
        query: {
          id,
        },
      });
    },

    /**
     * 在线客服页面
     */
    toLogin(path) {
      this.$router.push({
        path,
      });
    },

    /**
     * 图片加载失败处理
     */
    onImageError(event) {
      event.target.style.opacity = "0.35";
    },
  },
};
</script>

<style scoped lang="less">
/* 保留原来的导航渐变 */
.van-nav-bar {
  background: linear-gradient(30deg, #7d76ef, #d63f8c);
}

/* 只放大顶部标题，不改变导航栏高度和布局 */
/deep/ .van-nav-bar__title {
  color: #fff;
  font-size: 28px !important;
  font-weight: 600;
}

/* 保留原来的分类区域高度 */
/deep/ .van-tabs__wrap {
  height: 13vw;
  padding-bottom: 10px;
}

/* 保留原来的选中下划线颜色 */
/deep/ .van-tabs__line {
  background-color: #c571cf;
}

/* 只放大分类文字，不修改原来的分类间距 */
/deep/ .van-tab__text {
  font-size: 18px !important;
  line-height: 50px;
  white-space: nowrap;
}

/* 当前分类稍微加粗 */
/deep/ .van-tab--active .van-tab__text {
  font-weight: 600;
}

/* 自定义分类标题 */
.tab-title {
  position: relative;
  display: flex;
  min-height: 50px;
  font-size: 28px;
  line-height: 50px;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
}

/* 人氣右上角NEW图片 */
.new-mark {
  position: absolute;
  top: 3px;
  right: -25px;
  width: 30px;
  height: 16px;
  background: url("/img/new.png") center / contain no-repeat;
}

/* 隐藏加载默认文字 */
/deep/ .van-loading__text,
/deep/ .van-list__loading-text,
/deep/ .van-pull-refresh__text {
  display: none !important;
}

/deep/ .van-list__finished-text {
  font-size: 32px;
  color: #000;
}

/deep/ .van-pull-refresh__head {
  height: 100px;
}

/* 保留原来的两列布局 */
.list-item {
  display: flex;
  width: calc(100% - 7vw);
  margin: 10px auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}

/* 保留原来的单项宽度和底部间距 */
.movie-list-item {
  width: calc(50% - 16px);
  margin-bottom: -7vw;
}

/* 保留原来的封面圆角 */
.cover_img {
  overflow: hidden;
  border-radius: 20px;
  background-color: #f2f2f2;
}

.cover_img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* 保留原来的底部信息位置 */
.movie-list-item-bottom {
  position: relative;
  width: 100%;
  bottom: 6vw;
}

/* 保留原来的黑色透明信息背景 */
.movie-time-div {
  height: 8vw;
  color: #fff;
  border-radius: 0 0 40px 40px;
  background-color: rgba(0, 0, 0, 0.4);
}

.movie-list-item-bottom div {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

/* 视频名称 */
.movie-time-div span:first-child {
  width: 24vw;
  padding-left: 16px;
  overflow: hidden;
  font-size: 3vw;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 播放次数 */
.movie-count {
  flex-shrink: 0;
  padding-right: 10px;
  font-size: 12px;
  white-space: nowrap;
}

/* 保留原来的activeBg样式 */
.activeBg {
  color: rgb(197, 113, 207);
  font-weight: bold;
  background: url("/img/new.png") right top 5px / 30% no-repeat;
}
</style>